import { render, staticRenderFns } from "./school4.vue?vue&type=template&id=351f61d6&scoped=true&"
import script from "./school4.vue?vue&type=script&lang=js&"
export * from "./school4.vue?vue&type=script&lang=js&"
import style0 from "./school4.vue?vue&type=style&index=0&id=351f61d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351f61d6",
  null
  
)

export default component.exports